import { usePlexRoute } from '../usePlexRoute';

type Value = { permalink: string; commentsVisible: boolean } | null;
type Setter = (v: Value) => void;

export function useSelectedPlexQuestion(): [Value, Setter] {
  const [plexRoute, updatePlexRoute] = usePlexRoute();

  const selectedPlexQuestion =
    plexRoute?.selectedItem?.type === 'question'
      ? {
          permalink: plexRoute.selectedItem.permalink,
          commentsVisible: !!plexRoute.selectedItem.commentsVisible,
        }
      : null;

  const setSelectedPlexQuestion = (selectedPlexPost: Value): void => {
    if (selectedPlexPost != null) {
      const { permalink, commentsVisible } = selectedPlexPost;
      updatePlexRoute({ selectedItem: { type: 'question', permalink, commentsVisible } });
    } else {
      updatePlexRoute({ selectedItem: undefined });
    }
  };

  return [selectedPlexQuestion, setSelectedPlexQuestion];
}
